import React from "react";
import "./CVViewer.css";

export default function CVViewer({ cvUrl, onClose }) {
  if (!cvUrl) return null;

  return (
    <div className="cv-viewer-overlay" onClick={onClose}>
      <div className="cv-viewer-container" onClick={(e) => e.stopPropagation()}>
        <button className="cv-close-btn" onClick={onClose}>✕</button>
        <iframe
          src={cvUrl}
          title="CV Preview"
          className="cv-viewer-iframe"
          frameBorder="0"
        ></iframe>
        <a href={cvUrl} target="_blank" rel="noopener noreferrer" className="cv-download-btn">
          Download CV
        </a>
      </div>
    </div>
  );
}